package anjuros.development.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import anjuros.development.components.language.LanguageDropDown
import anjuros.development.components.language.LocalText
import anjuros.development.modules.Section
import anjuros.development.modules.Theme
import anjuros.development.util.Constants
import anjuros.development.util.MainHeaderContactStyle
import anjuros.development.util.NavigationItemStyle
import anjuros.development.util.rememberOrientation
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.textDecorationLine
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.icons.fa.FaBars
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.style.breakpoint.displayUntil
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun Header(onMenuCLicked:()->Unit) {

    Box(
        modifier = Modifier
            .fillMaxWidth()
            .height(80.px)
    ) {

            Row(
                verticalAlignment = Alignment.CenterVertically,
                modifier = Modifier
                    .align(Alignment.CenterStart)
                    .size(50.px).displayUntil(Breakpoint.LG)
            ) {

                FaBars(
                    modifier = Modifier

                        .margin(left = 20.px)
                        .color(Theme.Primary.rgb)
                        .onClick {
                            onMenuCLicked()
                        },
                    size = IconSize.XL
                )
            }


            Row(
                modifier = Modifier
                    .displayIfAtLeast(Breakpoint.LG)
                    .align(Alignment.CenterEnd)
                    .margin(right = 100.px),
                horizontalArrangement = Arrangement.spacedBy(30.px)
            ) {
                Section.entries.toTypedArray().forEach { section ->

                    Column(modifier = NavigationItemStyle.toModifier()) {
                        Link(
                            modifier = Modifier
                                .align(Alignment.CenterHorizontally)
                                .textDecorationLine(TextDecorationLine.None),
                            path = section.path
                        ) {
                            P(
                                attrs = Modifier
                                    .margin(topBottom = 0.px)
                                    .fontFamily(Constants.FONT_FAMILY)
                                    .fontSize(18.px)
                                    .color(Theme.Secondary.rgb)
                                    .fontWeight(FontWeight.Normal)
                                    .toAttrs()
                            ) {
                                Text(LocalText(section.subtitle))

                            }
                        }

                        Box(
                            modifier = Modifier.id("sectionUnderline")
                                .align(Alignment.CenterHorizontally).padding(right = 30.px)
                                .width(40.px).height(2.px).backgroundColor(
                                Theme.Primary.rgb
                            )
                        )
                    }

                }
        }
        LanguageDropDown(
            modifier = Modifier
                .align(Alignment.CenterEnd)
                .margin(right = 24.px)
        )

    }
}